import type { LucideIcon } from 'lucide-react';
import {
  Tag, ShoppingCart, ShoppingBag, Store, Package, Apple, Banana, Carrot, Beef, Fish, Milk, Coffee, Wine, Beer,
  Croissant, Cake, Pizza, Sandwich, Smartphone, Laptop, Headphones, Tv, Watch, Camera, Shirt, Footprints, Glasses,
  Crown, Gem, Scissors, Heart, Sparkles, Flower2, Pill, HeartPulse, Stethoscope, Thermometer, Baby, Home, SprayCan,
  Bath, Pen, BookOpen, Paperclip, Dumbbell, Bike, Wrench, Car, Dog, Cat, Gamepad2, Puzzle, Gift, Flame, IceCream,
  CupSoda, Popcorn, Cherry, Citrus, UtensilsCrossed, Bed, Lamp, Armchair, Backpack, Key, Music, Wallet, Briefcase,
  Calculator, DollarSign, Receipt, Banknote, CreditCard, Landmark, Wallet2, Coins, PiggyBank, WalletCards,
} from 'lucide-react';

export const POS_CATEGORY_ICONS: { name: string; icon: LucideIcon; labelKey: string }[] = [
  { name: 'tag', icon: Tag, labelKey: 'categoryIcon.tag' },
  { name: 'shopping-cart', icon: ShoppingCart, labelKey: 'categoryIcon.shoppingCart' },
  { name: 'shopping-bag', icon: ShoppingBag, labelKey: 'categoryIcon.shoppingBag' },
  { name: 'store', icon: Store, labelKey: 'categoryIcon.store' },
  { name: 'package', icon: Package, labelKey: 'categoryIcon.package' },
  { name: 'apple', icon: Apple, labelKey: 'categoryIcon.apple' },
  { name: 'banana', icon: Banana, labelKey: 'categoryIcon.banana' },
  { name: 'carrot', icon: Carrot, labelKey: 'categoryIcon.carrot' },
  { name: 'beef', icon: Beef, labelKey: 'categoryIcon.beef' },
  { name: 'fish', icon: Fish, labelKey: 'categoryIcon.fish' },
  { name: 'milk', icon: Milk, labelKey: 'categoryIcon.milk' },
  { name: 'coffee', icon: Coffee, labelKey: 'categoryIcon.coffee' },
  { name: 'wine', icon: Wine, labelKey: 'categoryIcon.wine' },
  { name: 'beer', icon: Beer, labelKey: 'categoryIcon.beer' },
  { name: 'croissant', icon: Croissant, labelKey: 'categoryIcon.croissant' },
  { name: 'cake', icon: Cake, labelKey: 'categoryIcon.cake' },
  { name: 'pizza', icon: Pizza, labelKey: 'categoryIcon.pizza' },
  { name: 'sandwich', icon: Sandwich, labelKey: 'categoryIcon.sandwich' },
  { name: 'smartphone', icon: Smartphone, labelKey: 'categoryIcon.smartphone' },
  { name: 'laptop', icon: Laptop, labelKey: 'categoryIcon.laptop' },
  { name: 'headphones', icon: Headphones, labelKey: 'categoryIcon.headphones' },
  { name: 'tv', icon: Tv, labelKey: 'categoryIcon.tv' },
  { name: 'watch', icon: Watch, labelKey: 'categoryIcon.watch' },
  { name: 'camera', icon: Camera, labelKey: 'categoryIcon.camera' },
  { name: 'shirt', icon: Shirt, labelKey: 'categoryIcon.shirt' },
  { name: 'footprints', icon: Footprints, labelKey: 'categoryIcon.footprints' },
  { name: 'glasses', icon: Glasses, labelKey: 'categoryIcon.glasses' },
  { name: 'crown', icon: Crown, labelKey: 'categoryIcon.crown' },
  { name: 'gem', icon: Gem, labelKey: 'categoryIcon.gem' },
  { name: 'scissors', icon: Scissors, labelKey: 'categoryIcon.scissors' },
  { name: 'heart', icon: Heart, labelKey: 'categoryIcon.heart' },
  { name: 'sparkles', icon: Sparkles, labelKey: 'categoryIcon.sparkles' },
  { name: 'flower-2', icon: Flower2, labelKey: 'categoryIcon.flower2' },
  { name: 'pill', icon: Pill, labelKey: 'categoryIcon.pill' },
  { name: 'heart-pulse', icon: HeartPulse, labelKey: 'categoryIcon.heartPulse' },
  { name: 'stethoscope', icon: Stethoscope, labelKey: 'categoryIcon.stethoscope' },
  { name: 'thermometer', icon: Thermometer, labelKey: 'categoryIcon.thermometer' },
  { name: 'baby', icon: Baby, labelKey: 'categoryIcon.baby' },
  { name: 'home', icon: Home, labelKey: 'categoryIcon.home' },
  { name: 'spray-can', icon: SprayCan, labelKey: 'categoryIcon.sprayCan' },
  { name: 'bath', icon: Bath, labelKey: 'categoryIcon.bath' },
  { name: 'pen', icon: Pen, labelKey: 'categoryIcon.pen' },
  { name: 'book-open', icon: BookOpen, labelKey: 'categoryIcon.bookOpen' },
  { name: 'paperclip', icon: Paperclip, labelKey: 'categoryIcon.paperclip' },
  { name: 'dumbbell', icon: Dumbbell, labelKey: 'categoryIcon.dumbbell' },
  { name: 'bike', icon: Bike, labelKey: 'categoryIcon.bike' },
  { name: 'wrench', icon: Wrench, labelKey: 'categoryIcon.wrench' },
  { name: 'car', icon: Car, labelKey: 'categoryIcon.car' },
  { name: 'dog', icon: Dog, labelKey: 'categoryIcon.dog' },
  { name: 'cat', icon: Cat, labelKey: 'categoryIcon.cat' },
  { name: 'gamepad-2', icon: Gamepad2, labelKey: 'categoryIcon.gamepad2' },
  { name: 'puzzle', icon: Puzzle, labelKey: 'categoryIcon.puzzle' },
  { name: 'gift', icon: Gift, labelKey: 'categoryIcon.gift' },
  { name: 'flame', icon: Flame, labelKey: 'categoryIcon.flame' },
  { name: 'ice-cream', icon: IceCream, labelKey: 'categoryIcon.iceCream' },
  { name: 'cup-soda', icon: CupSoda, labelKey: 'categoryIcon.cupSoda' },
  { name: 'popcorn', icon: Popcorn, labelKey: 'categoryIcon.popcorn' },
  { name: 'cherry', icon: Cherry, labelKey: 'categoryIcon.cherry' },
  { name: 'citrus', icon: Citrus, labelKey: 'categoryIcon.citrus' },
  { name: 'utensils-crossed', icon: UtensilsCrossed, labelKey: 'categoryIcon.utensilsCrossed' },
  { name: 'bed', icon: Bed, labelKey: 'categoryIcon.bed' },
  { name: 'lamp', icon: Lamp, labelKey: 'categoryIcon.lamp' },
  { name: 'armchair', icon: Armchair, labelKey: 'categoryIcon.armchair' },
  { name: 'backpack', icon: Backpack, labelKey: 'categoryIcon.backpack' },
  { name: 'key', icon: Key, labelKey: 'categoryIcon.key' },
  { name: 'music', icon: Music, labelKey: 'categoryIcon.music' },
  { name: 'wallet', icon: Wallet, labelKey: 'categoryIcon.wallet' },
  { name: 'briefcase', icon: Briefcase, labelKey: 'categoryIcon.briefcase' },
  { name: 'calculator', icon: Calculator, labelKey: 'categoryIcon.calculator' },
  { name: 'dollar-sign', icon: DollarSign, labelKey: 'categoryIcon.dollarSign' },
  { name: 'receipt', icon: Receipt, labelKey: 'categoryIcon.receipt' },
  { name: 'banknote', icon: Banknote, labelKey: 'categoryIcon.banknote' },
  { name: 'credit-card', icon: CreditCard, labelKey: 'categoryIcon.creditCard' },
  { name: 'landmark', icon: Landmark, labelKey: 'categoryIcon.landmark' },
  { name: 'wallet-2', icon: Wallet2, labelKey: 'categoryIcon.wallet2' },
  { name: 'coins', icon: Coins, labelKey: 'categoryIcon.coins' },
  { name: 'piggy-bank', icon: PiggyBank, labelKey: 'categoryIcon.piggyBank' },
  { name: 'wallet-cards', icon: WalletCards, labelKey: 'categoryIcon.walletCards' },
];

const ICON_MAP = new Map(POS_CATEGORY_ICONS.map((entry) => [entry.name, entry.icon]));

export function getPosCategoryIcon(name?: string | null): LucideIcon | undefined {
  if (!name) return undefined;
  return ICON_MAP.get(name);
}

/** Deterministic palette for automatic category color assignment. */
export const POS_CATEGORY_COLORS = [
  '#ef4444', '#f97316', '#f59e0b', '#84cc16', '#22c55e', '#10b981',
  '#14b8a6', '#06b6d4', '#0ea5e9', '#3b82f6', '#6366f1', '#8b5cf6',
  '#a855f7', '#d946ef', '#ec4899', '#f43f5e', '#78716c', '#64748b',
  '#475569', '#334155',
];

export function getDefaultCategoryColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % POS_CATEGORY_COLORS.length;
  return POS_CATEGORY_COLORS[index];
}

/** White inset ring so the active category stays obvious on any color. */
export const POS_CATEGORY_SELECTED_CLASS =
  'selected ring-[3px] ring-inset ring-white shadow-md';
